// /* eslint-disable no-constant-binary-expression */
// /* eslint-disable prefer-const */
// import { useEffect, useState } from 'react';
// import Form from 'react-bootstrap/Form';
// import { useTranslation } from 'react-i18next';
// import { useAppDispatch, useAppSelector } from '@store/hooks';
// import {
//   GetParametersByReportId,
//   GetReportsChartData,
//   GetReportsData
// } from '@store/NTX/Reports/ReportData/reportdataSlice';
// import TypeT from './TypeT';
// import TypeD from './TypeD';
// import TypeL from './TypeL';
// import { Card, CardBody, CardFooter, CardHeader } from '@components/card/card';
// import { Alert, Spinner } from 'react-bootstrap';
// import TabsReports from './TabsReports';
// import Loading from '@components/Shared/Loader/Loading';

// type DataReportType = {
//   reportData?: any[];
//   [key: string]: any;
// };
// const ReportsBuilder2 = ({ ReportId }: { ReportId: string }) => {
//   const [loadingData, setLoadingData] = useState(false);
//   const { t, i18n } = useTranslation();
//   const dispatch = useAppDispatch();
//   const [formData, setFormData] = useState<any>({});
//   const [DataReport, setDataReport] = useState<DataReportType>({});
//   const [DataChartReport, setDataChartReport] = useState<any[]>([]);
//   const { ParameterList: data, loading, error } = useAppSelector(state => state.ReportData);
//   const sortedList = data?.parameterList?.slice().sort((a, b) => a.sequnce - b.sequnce);

//   useEffect(() => {
//     setFormData({});
//     setDataReport({});

//     if (ReportId) {
//       dispatch(GetParametersByReportId(ReportId));
//     }
//   }, [ReportId, dispatch]);

//   const handleInputChange = (e: any) => {
//     const { name, type, value, checked } = e.target;
//     if (type === 'checkbox') {
//       const checkboxValue = checked ? '1' : '0';
//       setFormData({ ...formData, [name]: checkboxValue });
//     } else {
//       setFormData({ ...formData, [name]: value });
//     }
//   };

//   const List = sortedList?.map((item, index) => ({
//     id: item.id,
//     value: formData[item.id]
//   }));

//   const handleSubmit = async (e: any) => {
//     e.preventDefault();
//     setDataReport([]);
//     await new Promise(resolve => setTimeout(resolve, 50));
//     try {
//       setLoadingData(true);
//       let resDataReport;
//       resDataReport = await dispatch(GetReportsData(RequestData));
//       if (resDataReport.payload.succeeded === true) {
//         setDataReport(resDataReport.payload.data);
//       } else if (resDataReport.payload.succeeded === false) {
//         // هنا التعامل مع الخطأ
//       }

//       if (data && data?.chartList?.length > 0) {
//         const responsePromises = data?.chartList?.map(async item => {
//           const Request = {
//             reportChartId: item.id,
//             parameterList: List?.filter(f => f?.value?.trim() !== '')?.map(param => ({
//               id: param.id,
//               value: param.value
//             }))
//           };

//           const res = await dispatch(GetReportsChartData(Request));
//           return res.payload.data; // Return the response data
//         });
//         const responses = await Promise.all(responsePromises);

//         setDataChartReport(responses);
//       }
//     } catch (error) {
//       console.error('An error occurred while submitting the form:', error);
//     } finally {
//       setLoadingData(false);
//     }
//   };

//   // بيانات طلب طباعة للتفرير
//   const RequestData = {
//     reportQuery: {
//       reportId: ReportId,
//       parameterList: List?.filter(f => f?.value?.trim() !== '')?.map(item => ({
//         id: item.id,
//         value: item.value
//       }))
//     }
//   };

//   return (
//     <>
//       <div className='container mt-4'>
//         <Card>
//           <Loading loading={loading} error={error}>
//             <CardHeader className='d-flex justify-content-between align-items-center'>
//               <h5 className='mb-0'>{i18n.language === 'en' ? data.name : data.name2}</h5>
//               <div>
//                 <span className='me-2'>Total: {DataReport?.reportData?.length} Records</span>
//               </div>
//             </CardHeader>

//             <CardBody>
//               {false && (
//                 <Alert variant='danger' className='mb-4'>
//                   Error loading data: {'error'}
//                 </Alert>
//               )}

//               {/* Filters Section */}
//               <Card className='mb-4'>
//                 <CardHeader>Filters</CardHeader>
//                 <CardBody>
//                   <Form onSubmit={handleSubmit}>
//                     <div className='row'>
//                       {data.parameterList &&
//                         sortedList?.map((item, index) => {
//                           if (item.hasIn === false) {
//                             switch (item.dataType) {
//                               case 'DATE':
//                                 return (
//                                   <div key={item.id} className='col-xl-4 m-auto'>
//                                     <div className='form-group mb-3'>
//                                       <label className='form-label'>
//                                         {i18n.language === 'ar' ? item.lableText2 : item.lableText}
//                                       </label>
//                                       <Form.Control
//                                         className='form-control'
//                                         required={item.requiredFlag}
//                                         type='Date'
//                                         name={item.id}
//                                         onChange={handleInputChange}
//                                       />
//                                     </div>
//                                   </div>
//                                 );
//                               case 'NUMBER':
//                                 return (
//                                   <div key={item.id} className='col-xl-4 m-auto'>
//                                     <div className='form-group mb-3'>
//                                       <label className='form-label'>
//                                         {i18n.language === 'ar' ? item.lableText2 : item.lableText}
//                                       </label>
//                                       <Form.Control
//                                         className='form-control'
//                                         required={item.requiredFlag}
//                                         type='number'
//                                         name={item.id}
//                                         onChange={handleInputChange}
//                                       />
//                                     </div>
//                                   </div>
//                                 );
//                               case 'TEXT':
//                                 return (
//                                   <div key={item.id} className='col-xl-4 m-auto'>
//                                     <div className='form-group mb-3'>
//                                       <label className='form-label'>
//                                         {i18n.language === 'ar' ? item.lableText2 : item.lableText}
//                                       </label>
//                                       <Form.Control
//                                         className='form-control'
//                                         required={item.requiredFlag}
//                                         type='text'
//                                         autoComplete='off'
//                                         name={item.id}
//                                         onChange={handleInputChange}
//                                       />
//                                     </div>
//                                   </div>
//                                 );
//                               case 'TIME':
//                                 return (
//                                   <div key={item.id} className='col-xl-4 m-auto'>
//                                     <div className='form-group mb-3'>
//                                       <label className='form-label'>
//                                         {i18n.language === 'ar' ? item.lableText2 : item.lableText}
//                                       </label>
//                                       <Form.Control
//                                         className='form-control'
//                                         required={item.requiredFlag}
//                                         type='time'
//                                         name={item.id}
//                                         onChange={handleInputChange}
//                                       />
//                                     </div>
//                                   </div>
//                                 );
//                               case 'BOOLEAN':
//                                 return (
//                                   <div key={item.id} className='col-xl-4 m-auto'>
//                                     <div className='form-group mb-3'>
//                                       <label className='form-label'>
//                                         {i18n.language === 'ar' ? item.lableText2 : item.lableText}
//                                       </label>
//                                       <Form.Check
//                                         style={{ margin: '10px 20px' }}
//                                         type='switch'
//                                         // label={
//                                         //   i18n.language === "ar" ? item.lable2 : item.lable
//                                         // }
//                                         name={item.id}
//                                         defaultChecked={false}
//                                         onChange={handleInputChange}
//                                       />
//                                     </div>
//                                   </div>
//                                 );
//                               case 'T':
//                                 return (
//                                   <div key={item.id} className='col-xl-4 m-auto'>
//                                     <TypeT key={item.id} item={item} formData={formData} setFormData={setFormData} />
//                                   </div>
//                                 );
//                               case 'D':
//                                 return (
//                                   <div key={item.id} className='col-xl-4 m-auto'>
//                                     <TypeD key={item.id} item={item} formData={formData} setFormData={setFormData} />
//                                   </div>
//                                 );
//                               case 'L':
//                                 return (
//                                   <div key={item.id} className='col-xl-4 m-auto'>
//                                     <TypeL key={item.id} item={item} formData={formData} setFormData={setFormData} />
//                                   </div>
//                                 );
//                             }
//                           }
//                         })}
//                     </div>

//                     <div className='text-end'>
//                       <button disabled={loadingData} type='submit' className='btn btn-lg me-1 btn-theme mb-1 '>
//                         {loadingData ? (
//                           <>
//                             <Spinner
//                               as='span'
//                               animation='border'
//                               size='sm'
//                               role='status'
//                               aria-hidden='true'
//                               className='me-2'
//                             />
//                             Loading...
//                           </>
//                         ) : (
//                           'Load Data'
//                         )}
//                       </button>
//                     </div>
//                   </Form>
//                 </CardBody>
//               </Card>

//               {/* Results Section */}
//               {loadingData ? (
//                 <div className='text-center my-5'>
//                   <Spinner animation='border' role='status'>
//                     <span className='visually-hidden'>Loading...</span>
//                   </Spinner>
//                   <p className='mt-2'>Loading report data...</p>
//                 </div>
//               ) : Array.isArray(DataReport?.reportData) && DataReport.reportData.length > 0 ? (
//                 <div>
//                   <TabsReports
//                     RequestPrint={RequestData}
//                     DataReport={DataReport}
//                     chartList={data?.chartList}
//                     DataChartReport={DataChartReport}
//                   />
//                 </div>
//               ) : (
//                 <div className='text-center py-5'>
//                   <p>No data available. Set your filters and click "Load Data" to fetch reports.</p>
//                 </div>
//               )}
//             </CardBody>

//             {Array.isArray(DataReport?.reportData) && DataReport.reportData.length > 0 && (
//               <CardFooter className='text-muted'>Report generated on {new Date().toLocaleString()}</CardFooter>
//             )}
//           </Loading>
//         </Card>
//       </div>
//     </>
//   );
// };

// export default ReportsBuilder2;
// -------------------------------------------------------------------------------------------------------------
/* eslint-disable no-constant-binary-expression */
/* eslint-disable prefer-const */
// import { useEffect, useState, useCallback, useMemo } from 'react';
// import Form from 'react-bootstrap/Form';
// import { useTranslation } from 'react-i18next';
// import { useAppDispatch, useAppSelector } from '@store/hooks';
// import {
//   GetParametersByReportId,
//   GetReportsChartData,
//   GetReportsData
// } from '@store/NTX/Reports/ReportData/reportdataSlice';
// import TypeT from './TypeT';
// import TypeD from './TypeD';
// import TypeL from './TypeL';
// import { Card, CardBody, CardFooter, CardHeader } from '@components/card/card';
// import { Spinner } from 'react-bootstrap';
// import TabsReports from './TabsReports';
// import Loading from '@components/Shared/Loader/Loading';

// type DataReportType = {
//   reportData?: any[];
//   [key: string]: any;
// };

// const ReportsBuilder2 = ({ ReportId }: { ReportId: string }) => {
//   const { t, i18n } = useTranslation();
//   const dispatch = useAppDispatch();

//   // State management
//   const [loadingData, setLoadingData] = useState(false);
//   const [formData, setFormData] = useState<Record<string, any>>({});
//   const [DataReport, setDataReport] = useState<DataReportType>({});
//   const [DataChartReport, setDataChartReport] = useState<any[]>([]);

//   // Redux data
//   const { ParameterList: data, loading, error } = useAppSelector(state => state.ReportData);

//   // Memoized sorted list
//   const sortedList = useMemo(
//     () => data?.parameterList?.slice().sort((a, b) => a.sequnce - b.sequnce) || [],
//     [data?.parameterList]
//   );

//   // Filtered parameter list for request
//   const parameterListForRequest = useMemo(
//     () =>
//       sortedList
//         .filter(item => formData[item.id]?.trim() !== '')
//         .map(item => ({
//           id: item.id,
//           value: formData[item.id]
//         })),
//     [sortedList, formData]
//   );

//   // Request data memoized
//   const RequestData = useMemo(
//     () => ({
//       reportQuery: {
//         reportId: ReportId,
//         parameterList: parameterListForRequest
//       }
//     }),
//     [ReportId, parameterListForRequest]
//   );

//   // Reset form when ReportId changes
//   useEffect(() => {
//     setFormData({});
//     setDataReport({});
//     if (ReportId) {
//       dispatch(GetParametersByReportId(ReportId));
//     }
//   }, [ReportId, dispatch]);

//   // Optimized input change handler
//   const handleInputChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
//     const { name, type, value, checked } = e.target;
//     setFormData(prev => ({
//       ...prev,
//       [name]: type === 'checkbox' ? (checked ? '1' : '0') : value
//     }));
//   }, []);

//   // Form submission handler
//   const handleSubmit = useCallback(
//     async (e: React.FormEvent) => {
//       e.preventDefault();
//       setDataReport({});

//       try {
//         setLoadingData(true);

//         // Fetch report data
//         const resDataReport = await dispatch(GetReportsData(RequestData));
//         if (resDataReport.payload?.succeeded) {
//           setDataReport(resDataReport.payload.data);
//         }

//         // Fetch chart data if available
//         if (data?.chartList?.length) {
//           const chartRequests = data.chartList.map(item => ({
//             reportChartId: item.id,
//             parameterList: parameterListForRequest
//           }));

//           const chartResults = await Promise.all(chartRequests.map(req => dispatch(GetReportsChartData(req))));

//           setDataChartReport(chartResults.map(res => res.payload.data));
//         }
//       } catch (error) {
//         console.error('Form submission error:', error);
//       } finally {
//         setLoadingData(false);
//       }
//     },
//     [RequestData, data?.chartList, dispatch, parameterListForRequest]
//   );

//   const renderParameterInput = (item: any) => {
//     const commonProps = {
//       className: 'form-control',
//       required: item.requiredFlag,
//       name: item.id,
//       onChange: handleInputChange
//     };

//     const label = i18n.language === 'ar' ? item.lableText2 : item.lableText;

//     switch (item.dataType) {
//       case 'DATE':
//         return <Form.Control key={item.id} type='date' {...commonProps} />;
//       case 'NUMBER':
//         return <Form.Control key={item.id} type='number' {...commonProps} />;
//       case 'TEXT':
//         return <Form.Control key={item.id} type='text' autoComplete='off' {...commonProps} />;
//       case 'TIME':
//         return <Form.Control key={item.id} type='time' {...commonProps} />;
//       case 'BOOLEAN':
//         return (
//           <Form.Check
//             key={item.id}
//             style={{ margin: '10px 20px' }}
//             type='switch'
//             name={item.id}
//             defaultChecked={false}
//             onChange={handleInputChange}
//           />
//         );
//       case 'T':
//         return <TypeT key={item.id} item={item} formData={formData} setFormData={setFormData} />;
//       case 'D':
//         return <TypeD key={item.id} item={item} formData={formData} setFormData={setFormData} />;
//       case 'L':
//         return <TypeL key={item.id} item={item} formData={formData} setFormData={setFormData} />;
//       default:
//         return null;
//     }
//   };

//   // Memoized report title
//   const reportTitle = useMemo(
//     () => (i18n.language === 'en' ? data?.name : data?.name2),
//     [i18n.language, data?.name, data?.name2]
//   );

//   return (
//     <div className='  '>
//       {/* Filters Section */}
//       <Card className='mb-4'>
//         <CardHeader>{t('filters')}</CardHeader>
//         <CardBody>
//           <Form onSubmit={handleSubmit}>
//             <div className='row'>
//               {sortedList
//                 .filter(item => item.hasIn === false)
//                 .map(item => (
//                   <div key={item.id} className='col-xl-4 m-auto'>
//                     <div className='form-group mb-3'>
//                       <label className='form-label'>{i18n.language === 'ar' ? item.lableText2 : item.lableText}</label>
//                       {renderParameterInput(item)}
//                     </div>
//                   </div>
//                 ))}
//             </div>

//             <div className='text-end'>
//               <button disabled={loadingData} type='submit' className='btn btn-lg me-1 btn-theme mb-1'>
//                 {loadingData ? (
//                   <>
//                     <Spinner as='span' animation='border' size='sm' role='status' aria-hidden='true' className='me-2' />
//                     {t('loading')}
//                   </>
//                 ) : (
//                   'Load Data'
//                 )}
//               </button>
//             </div>
//           </Form>
//         </CardBody>
//       </Card>
//       <Card>
//         <Loading loading={loading} error={error}>
//           <CardHeader className='d-flex justify-content-between align-items-center'>
//             <h5 className='mb-0'>{reportTitle}</h5>
//             {DataReport?.reportData && <span>Total: {DataReport.reportData.length} Records</span>}
//           </CardHeader>

//           <CardBody>
//             {/* Results Section */}
//             {loadingData ? (
//               <div className='text-center my-5'>
//                 <Spinner animation='border' role='status' />
//                 <p className='mt-2'> Loading...</p>
//               </div>
//             ) : Array.isArray(DataReport?.reportData) && DataReport.reportData.length > 0 ? (
//               <div>
//                 <TabsReports
//                   RequestPrint={RequestData}
//                   DataReport={DataReport}
//                   chartList={data?.chartList}
//                   DataChartReport={DataChartReport}
//                 />
//               </div>
//             ) : (
//               <div className='text-center py-5'>
//                 <p>No data available. Set your filters and click "Load Data" to fetch reports.</p>
//               </div>
//             )}
//           </CardBody>

//           {Array.isArray(DataReport?.reportData) && DataReport.reportData.length > 0 && (
//             <CardFooter className='text-muted'>Report generated on {new Date().toLocaleString()}</CardFooter>
//           )}
//         </Loading>
//       </Card>
//     </div>
//   );
// };

// export default ReportsBuilder2;

import { useEffect, useState, useCallback, useMemo } from 'react';
import Form from 'react-bootstrap/Form';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import {
  GetParametersByReportId,
  GetReportsChartData,
  GetReportsData
} from '@store/NTX/Reports/ReportData/reportdataSlice';
import TypeT from './TypeT';
import TypeD from './TypeD';
import TypeL from './TypeL';
import { Card, CardBody } from '@components/card/card';
import { Spinner } from 'react-bootstrap';
import TabsReports from './TabsReports';
import Loading from '@components/Shared/Loader/Loading';

type DataReportType = {
  reportData?: any[];
  [key: string]: any;
};

const ReportsBuilder2 = ({ ReportId }: { ReportId: string }) => {
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();

  // State management
  const [loadingData, setLoadingData] = useState(false);
  const [formData, setFormData] = useState<Record<string, any>>({});
  const [DataReport, setDataReport] = useState<DataReportType>({});
  const [DataChartReport, setDataChartReport] = useState<any[]>([]);

  // Redux data
  const { ParameterList: data, loading, error } = useAppSelector(state => state.ReportData);

  // Memoized sorted list
  const sortedList = useMemo(
    () => data?.parameterList?.slice().sort((a, b) => a.sequnce - b.sequnce) || [],
    [data?.parameterList]
  );

  // Filtered parameter list for request
  const parameterListForRequest = useMemo(
    () =>
      sortedList
        .filter(item => (formData[item.id] ?? '').toString().trim() !== '')
        .map(item => ({
          id: item.id,
          value: formData[item.id]
        })),
    [sortedList, formData]
  );

  // Request data memoized
  const RequestData = useMemo(
    () => ({
      reportQuery: {
        reportId: ReportId,
        parameterList: parameterListForRequest
      }
    }),
    [ReportId, parameterListForRequest]
  );

  // Reset form when ReportId changes
  useEffect(() => {
    setFormData({});
    setDataReport({});
    if (ReportId) {
      dispatch(GetParametersByReportId(ReportId));
    }
  }, [ReportId, dispatch]);

  // Optimized input change handler
  const handleInputChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, type, value, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? (checked ? '1' : '0') : value
    }));
  }, []);

  // Form submission handler
  const handleSubmit = useCallback(
    async (e: React.FormEvent) => {
      e.preventDefault();
      setDataReport({});

      try {
        setLoadingData(true);

        // Fetch report data
        const resDataReport = await dispatch(GetReportsData(RequestData));
        if (resDataReport.payload?.succeeded) {
          setDataReport(resDataReport.payload.data);
        }

        // Fetch chart data if available
        if (data?.chartList?.length) {
          const chartRequests = data.chartList.map(item => ({
            reportChartId: item.id,
            parameterList: parameterListForRequest
          }));

          const chartResults = await Promise.all(chartRequests.map(req => dispatch(GetReportsChartData(req))));

          setDataChartReport(chartResults.map(res => res.payload.data));
        }
      } catch (error) {
        console.error('Form submission error:', error);
      } finally {
        setLoadingData(false);
      }
    },
    [RequestData, data?.chartList, dispatch, parameterListForRequest]
  );

  const renderParameterInput = (item: any) => {
    const commonProps = {
      className: 'form-control',
      required: item.requiredFlag,
      name: item.id,
      onChange: handleInputChange,
      value: formData[item.id] || ''
    };

    const label = i18n.language === 'ar' ? item.lableText2 : item.lableText;

    switch (item.dataType) {
      case 'DATE':
        return (
          <div className='input-group'>
            <span className='input-group-text'>
              <i className='bi bi-calendar'></i>
            </span>
            <Form.Control type='date' {...commonProps} />
          </div>
        );
      case 'NUMBER':
        return (
          <div className='input-group'>
            <span className='input-group-text'>
              <i className='bi bi-123'></i>
            </span>
            <Form.Control type='number' {...commonProps} />
          </div>
        );
      case 'TEXT':
        return (
          <div className='input-group'>
            <span className='input-group-text'>
              <i className='bi bi-fonts'></i>
            </span>
            <Form.Control type='text' autoComplete='off' {...commonProps} />
          </div>
        );
      case 'TIME':
        return (
          <div className='input-group'>
            <span className='input-group-text'>
              <i className='bi bi-clock'></i>
            </span>
            <Form.Control type='time' {...commonProps} />
          </div>
        );
      case 'BOOLEAN':
        return (
          <Form.Check
            type='switch'
            name={item.id}
            checked={formData[item.id] === '1'}
            onChange={handleInputChange}
            label={label}
            className='mt-2'
          />
        );
      case 'T':
        return <TypeT item={item} formData={formData} setFormData={setFormData} />;
      case 'D':
        return <TypeD item={item} formData={formData} setFormData={setFormData} />;
      case 'L':
        return <TypeL item={item} formData={formData} setFormData={setFormData} />;
      default:
        return null;
    }
  };

  return (
    <div className='px-2 py-0'>
      <div className='row g-4'>
        {/* ✅ قسم الفلاتر - أعلى الشاشة */}
        <div className='col-12'>
          <Card className='border-0 shadow-sm bg-body'>
            <div className='card-header bg-theme bg-opacity-10 border-bottom'>
              <h6 className='mb-0'>
                <i className='bi bi-sliders me-2'></i>
                {t('ReportFilters')}
              </h6>
            </div>

            <CardBody>
              <Loading loading={loading} error={error}>
                <Form onSubmit={handleSubmit}>
                  <div className='row g-3'>
                    {sortedList
                      .filter(item => !item.hasIn)
                      .map(item => (
                        <div key={item.id} className='col-md-4 col-lg-3'>
                          <div className='form-group'>
                            <label className='form-label small fw-semibold mb-2'>
                              {i18n.language === 'ar' ? item.lableText2 : item.lableText}
                              {item.requiredFlag && <span className='text-danger ms-1'>*</span>}
                            </label>
                            {renderParameterInput(item)}
                          </div>
                        </div>
                      ))}

                    {/* ✅ الأزرار */}
                    <div className='col-12'>
                      <div className='border-top pt-4 mt-2'>
                        <div className='d-flex justify-content-between align-items-center'>
                          <div>
                            {Object.keys(formData).length > 0 && (
                              <button
                                type='button'
                                className='btn btn-outline-secondary btn-sm'
                                onClick={() => setFormData({})}
                              >
                                <i className='bi bi-x-circle me-1'></i>
                                {t('ClearAll')}
                              </button>
                            )}
                          </div>

                          <button disabled={loadingData} type='submit' className='btn btn-theme px-4'>
                            {loadingData ? (
                              <>
                                <Spinner as='span' animation='border' size='sm' className='me-2' />
                                {t('LoadingDataShort')}
                              </>
                            ) : (
                              <>
                                <i className='bi bi-cloud-download me-2'></i>
                                {t('LoadData')}
                              </>
                            )}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </Form>
              </Loading>
            </CardBody>
          </Card>
        </div>

        {/* ✅ قسم النتائج - أسفل الفلاتر مباشرة */}
        <div className='col-12'>
          <Card className='border-0 shadow-sm bg-body'>
            <div className='card-header border-bottom'>
              <div className='d-flex align-items-center justify-content-between'>
                <h6 className='mb-0 d-flex align-items-center'>
                  <i className='bi bi-table me-2'></i>
                  {t('ReportResults')}
                  {DataReport?.reportData && (
                    <div className='badge bg-success bg-opacity-10 text-success border border-success border-opacity-25 px-3 py-2 ms-2'>
                      <i className='bi bi-check-circle me-1'></i>
                      {t('ReportRecordsCount', { count: DataReport.reportData.length })}
                    </div>
                  )}
                </h6>

                {DataReport?.reportData && (
                  <div className='text-muted small'>
                    {t('LastUpdateTime', { time: new Date().toLocaleTimeString() })}
                  </div>
                )}
              </div>
            </div>

            <CardBody className='p-0'>
              {loadingData ? (
                <div className='d-flex flex-column align-items-center justify-content-center py-5'>
                  <Loading loading={true} Type='Dots' />
                  <h5 className='mb-2'>{t('LoadingReportDataTitle')}</h5>
                  <p className='text-muted'>{t('PleaseWait')}</p>
                </div>
              ) : Array.isArray(DataReport?.reportData) && DataReport.reportData.length > 0 ? (
                <div className='py-2'>
                  <TabsReports
                    RequestPrint={RequestData}
                    DataReport={DataReport}
                    chartList={data?.chartList}
                    DataChartReport={DataChartReport}
                  />
                </div>
              ) : (
                <div className='d-flex flex-column align-items-center justify-content-center py-5'>
                  <div className='bg-light bg-opacity-25 rounded-circle p-4 d-inline-block mb-3'>
                    <i className='bi bi-graph-up display-4 text-muted'></i>
                  </div>
                  <h5 className='mb-2'>{t('NoReportDataTitle')}</h5>
                  <p className='text-muted text-center mb-0'>
                    {t('NoReportDataDescription')}
                  </p>
                </div>
              )}
            </CardBody>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default ReportsBuilder2;

